import { motion } from 'framer-motion';

const FILES_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/files`;

const GALLERY_PHOTOS = [
  'hooyos-place/gallery/4cd0cfd7-2550-4a66-b40a-779ef5f6abe6.jpeg',
  'hooyos-place/gallery/ea772e4f-6f4b-4a0e-b6ec-2f2eb6b4b48a.jpeg',
  'hooyos-place/gallery/48857230-01ca-4688-b472-793fc3897522.jpeg',
  'hooyos-place/gallery/f927e7f9-29b1-442f-9d7c-cd79ee5cfeae.jpeg',
  'hooyos-place/gallery/c5ece1d5-ae17-411b-a820-a935cf2ff02a.jpeg',
  'hooyos-place/gallery/acf032e3-697a-4ab8-9992-30c4c6c81d14.jpeg',
  'hooyos-place/gallery/0f5fdb2f-f7d8-4600-a78b-842e323ad3fd.jpeg',
];

const GallerySection = () => (
  <section className="py-12 md:py-20 bg-background relative overflow-hidden" data-testid="gallery-section">
    <div className="container mx-auto px-4 mb-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.6 }}
        className="text-center space-y-4"
      >
        <span className="inline-block bg-accent/15 text-accent-foreground text-sm font-bold px-5 py-2 rounded-full tracking-wide uppercase">
          Our Space
        </span>
        <h2 className="font-fredoka font-bold text-4xl sm:text-5xl" data-testid="gallery-heading">
          <span className="text-primary">Take a </span>
          <span className="text-secondary">Peek </span>
          <span className="text-accent">Inside</span>
        </h2>
        <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
          A warm, colorful environment where children feel safe, inspired, and excited to learn every day.
        </p>
      </motion.div>
    </div>

    {/* Scrolling Marquee */}
    <style>{`
      @keyframes galleryMarquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
      .gallery-marquee { display: flex; gap: 16px; width: max-content; animation: galleryMarquee 30s linear infinite; }
      .gallery-marquee:hover { animation-play-state: paused; }
    `}</style>
    <div className="overflow-hidden" data-testid="gallery-marquee">
      <div className="gallery-marquee">
        {[...GALLERY_PHOTOS, ...GALLERY_PHOTOS].map((path, i) => (
          <div key={i} className="flex-shrink-0 w-60 h-44 md:w-80 md:h-56 rounded-2xl overflow-hidden shadow-soft border border-border/20">
            <img src={`${FILES_BASE}/${path}`} alt="Our daycare space" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default GallerySection;
